<template>
  <div class="product-filter">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-top="-4"
      offset-y
      origin="center center"
      transition="slide-y-transition"
      content-class="snt-menu"
      @input="changeDialog($event)">
      <template #activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          :loading="$apollo.loading"
          :ripple="false"
          :height="40"
          color="#E4E4E4"
          block
          outlined
          v-on="on">
          <v-icon class="secondary--text">
            mdi-filter-variant
          </v-icon>
          <div
            :style="{ maxWidth: '180px' }"
            class="text-overflow secondary--text subtitle-1 mx-3">
            {{ activeLabel }}
          </div>
          <v-icon class="secondary--text">
            mdi-menu-down
          </v-icon>
        </v-btn>
      </template>
      <v-card
        v-click-outside="{ handler: onClickOutside }"
        flat>
        <v-card-text class="d-flex select-filter">
          <div class="main-filter">
            <div
              v-for="mainMenu of mainMenuList"
              :key="mainMenu.model"
              class="mb-3 cs-pointer"
              @click="setActiveSubMenu(mainMenu.model)">
              <v-checkbox
                :input-value="isFilterCheck(filter, mainMenu.model)"
                :ripple="false"
                :label="mainMenu.label"
                class="w-100"
                hide-details
                readonly
                dense>
                <template #label>
                  <div class="d-flex align-center w-100">
                    <div> {{ mainMenu.label }}</div>
                    <v-spacer />
                    <v-icon
                      v-if="activeSubmenu === mainMenu.model"
                      color="primary"
                      class="mr-3 ml-auto icon">
                      mdi-chevron-right
                    </v-icon>
                  </div>
                </template>
              </v-checkbox>
            </div>
          </div>
          <div class="sub-filter">
            <div
              v-if="activeSubmenu === 'platform'"
              class="d-flex flex-column">
              <div class="flex-grow-1 mt-1">
                <v-checkbox
                  v-model="filter.shopee"
                  :ripple="false"
                  label="shopee"
                  class="mb-3"
                  hide-details
                  dense />
                <v-checkbox
                  v-model="filter.lazada"
                  :ripple="false"
                  label="lazada"
                  hide-details
                  dense />
              </div>
            </div>
            <v-virtual-scroll
              v-else
              :items="items"
              class="overflow-x-hidden"
              bench="3"
              height="240"
              item-height="40">
              <template #default="{ item, index }">
                <v-checkbox
                  v-model="filter[activeSubmenu]"
                  :style="{ height: '32px' }"
                  :value="item.value"
                  :ripple="false"
                  :label="item.name"
                  :readonly="(isShopee || isLazada) && filter[activeSubmenu] === item.value"
                  class="align-center"
                  hide-details
                  dense />
                <infinite-loading
                  v-if="index === (items.length - 1)"
                  @infinite="infiniteHandler($event)">
                  <div slot="no-more" />
                  <div slot="no-results" />
                </infinite-loading>
              </template>
            </v-virtual-scroll>
          </div>
        </v-card-text>
        <v-card-actions class="pb-5 px-5 gap-1">
          <v-spacer />
          <v-btn
            :ripple="false"
            color="primary"
            rounded
            text
            @click="setMenu(false)">
            ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            depressed
            rounded
            @click="submit()">
            นำไปใช้
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import {
  GET_PRODUCT_BRAND_LIST,
  GET_PRODUCT_CATEGORY_LIST,
  GET_STOCKS
} from '@/resources/graphql'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    platform: {
      type: String,
      default: ''
    },
    needStock: Boolean
  },
  apollo: {
    stocks: {
      query: GET_STOCKS,
      variables () {
        return {
          page: 1,
          perPage: this.perPage,
          orderBy: 'id_ASC',
          shopee: this.isShopee,
          lazada: this.isLazada
        }
      },
      update ({ stocks }) {
        return {
          ...stocks,
          nodes: stocks.nodes.map((node) => ({
            name: node.name,
            value: node.id
          }))
        }
      }
    },
    productCategoryList: {
      query: GET_PRODUCT_CATEGORY_LIST,
      variables () {
        return {
          page: 1,
          perPage: this.perPage,
          sort: "name_ASC"
        }
      },
      update ({ productCategoryList }) {
        return {
          ...productCategoryList,
          nodes: productCategoryList.nodes.map((node) => ({
            name: node.name,
            value: node.id
          }))
        }
      }
    },
    productBrandList: {
      query: GET_PRODUCT_BRAND_LIST,
      variables () {
        return {
          page: 1,
          perPage: this.perPage,
          sort: "name_ASC"
        }
      },
      update ({ productBrandList }) {
        return {
          ...productBrandList,
          nodes: productBrandList.nodes.map((node) => ({
            name: node.name,
            value: node.id
          }))
        }
      }
    }
  },
  data () {
    return {
      menu: false,
      platformSubMenuVisible: false,
      inventoryMenuVisible: false,
      activeSubmenu: 'stockId',
      mainMenuList: [
        {
          model: 'categoryId',
          label: 'เลือกตามหมวดหมู่'
        },
        {
          model: 'stockId',
          label: 'เลือกตามคลัง'
        },
        {
          model: 'brandId',
          label: 'เลือกตามแบรนด์'
        },
        {
          model: 'platform',
          label: 'เลือกตาม Platform'
        }
      ],
      filter: this.$_.cloneDeep(this.value),
      perPage: 10,
      stockPage: 1,
      stocks: {
        nodes: []
      },
      productBrandPage: 1,
      productBrandList: {
        nodes: []
      },
      productCategoryPage: 1,
      productCategoryList: {
        nodes: []
      }
    }
  },
  computed: {
    items () {
      if (this.activeSubmenu === 'categoryId') {
        return this.productCategoryList.nodes
      }
      if (this.activeSubmenu === 'stockId') {
        return this.stocks.nodes
      }
      if (this.activeSubmenu === 'brandId') {
        return this.productBrandList.nodes
      }
      return []
    },
    activeLabel () {
      let label = 'แสดงทั้งหมด'
      const actives = this.mainMenuList.filter((item) => this.isFilterCheck(this.value, item.model))
      if (actives.length) {
        const str = actives.map((item) => item.label)
        label = this.$_.join(str, ', ')
      }
      return label
    },
    isShopee () {
      return this.platform === 'shopee'
    },
    isLazada () {
      return this.platform === 'lazada'
    }
  },
  methods: {
    async infiniteHandler ($state) {
      if (this.activeSubmenu === 'categoryId') {
        if (this.productCategoryList.hasNextPage) {
          this.productCategoryPage += 1
          await this.$apollo.queries.productCategoryList.fetchMore({
            variables: {
              page: this.productCategoryPage,
              perPage: this.perPage
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              const { hasNextPage, nodes } = fetchMoreResult.productCategoryList
              return ({
                productCategoryList: {
                  __typename: previousResult.productCategoryList.__typename,
                  nodes: this.$_.uniqBy([
                    ...previousResult.productCategoryList.nodes,
                    ...nodes
                  ], 'id'),
                  hasNextPage
                }
              })
            }
          })
          $state.loaded()
        } else {
          $state.complete()
        }
      } else if (this.activeSubmenu === 'stockId') {
        if (this.stocks.hasNextPage) {
          this.stockPage += 1
          await this.$apollo.queries.stocks.fetchMore({
            variables: {
              page: this.stockPage,
              perPage: this.perPage,
              orderBy: 'id_ASC',
              shopee: this.isShopee,
              lazada: this.isLazada
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              const { hasNextPage, nodes } = fetchMoreResult.stocks
              return ({
                stocks: {
                  __typename: previousResult.stocks.__typename,
                  nodes: this.$_.uniqBy([
                    ...previousResult.stocks.nodes,
                    ...nodes
                  ], 'id'),
                  hasNextPage
                }
              })
            }
          })
          $state.loaded()
        } else {
          $state.complete()
        }
      } else if (this.activeSubmenu === 'brandId') {
        if (this.productBrandList.hasNextPage) {
          this.productBrandPage += 1
          await this.$apollo.queries.productBrandList.fetchMore({
            variables: {
              page: this.productBrandPage,
              perPage: this.perPage
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              const { hasNextPage, nodes } = fetchMoreResult.productBrandList
              return ({
                productBrandList: {
                  __typename: previousResult.productBrandList.__typename,
                  nodes: this.$_.uniqBy([
                    ...previousResult.productBrandList.nodes,
                    ...nodes
                  ], 'id'),
                  hasNextPage
                }
              })
            }
          })
          $state.loaded()
        } else {
          $state.complete()
        }
      }
    },
    isFilterCheck (value, model) {
      if (model === 'platform') {
        return value.shopee || value.lazada
      }
      if (this.$_.isArray(value[model])) {
        return value[model].length
      }
      return !!value[model]
    },
    onClickOutside () {
      if (!this.menu) return
      this.onFilter()
    },
    submit () {
      this.onFilter()
      this.setMenu(false)
    },
    setActiveSubMenu (activeMenuName = '') {
      this.activeSubmenu = activeMenuName
    },
    countLabel (subMenu) {
      if (this.$_.has(subMenu, 'productsCount')) return `(${subMenu.productsCount})`
      return ''
    },
    onFilter () {
      const value = this.$_.cloneDeep(this.filter)
      this.$emit('onFilter', value)
    },
    changeDialog (menu) {
      if (menu) {
        this.filter = this.$_.cloneDeep(this.value) || {}
      }
    },
    setMenu (menu = false) {
      this.menu = menu
    }
  }
}
</script>

<style lang="scss" scoped>
  .select-filter {
    background-color: white;
    overflow-y: auto;
    .main-filter {
      width: 47%;
      min-width: 218px;
      max-width: 218px;
      border-right: 1px solid #e4e4e4;
      margin-right: 20px;
    }
    .sub-filter {
      min-width: 218px;
      height: 100%;
      flex-grow: 1;
    }
  }
</style>
